export default values => ({
  ...values,
  nip: values.nip || ''
});
